<template>
  <div class="generation">
    <Header />
    <Layout>
      <div class="company-outer">
        <div class="company-info">
          <div style="line-height: 1.6" class="iconfont">&#xe709;</div>
          <div class="company-name">{{ data.sellerCompanyName }}</div>
        </div>
        <div class="company-content">
          <div class="order-details">
            <div class="operation">
              <div
                style="display: flex; justify-content: flex-start;align-items: center; height: 1.098rem;padding: 0.113rem 0 0.32rem 0"
                class="item"
              >
                <p
                  class="van-cell__title van-field__label"
                  style="color: rgb(51, 51, 51); font-size: 0.68267rem;width: 3.55rem;"
                >
                  开票类型
                </p>
                <van-radio-group
                  label-width="3.55rem"
                  label
                  style="height: 100%; display: flex;justify-content: flex-start; align-items: center"
                  v-model="buyerVo.nature"
                  @change="changeNatureType"
                >
                  <van-radio
                    icon-size=".64rem"
                    style="height: 0.87rem;font-size: .68267rem; margin-right: .576rem"
                    :name="0"
                  >
                    企业
                    <div
                      slot="icon"
                      slot-scope="props"
                      :class="
                        props.checked ? 'radio-active radio-wrp' : 'radio-wrp'
                      "
                    ></div>
                  </van-radio>
                  <van-radio
                    icon-size=".64rem"
                    style="height: 0.87rem;font-size: .68267rem; margin-right: .576rem"
                    :name="1"
                  >
                    个人
                    <div
                      slot="icon"
                      slot-scope="props"
                      :class="
                        props.checked ? 'radio-active radio-wrp' : 'radio-wrp'
                      "
                    ></div>
                  </van-radio>
                  <van-radio
                    icon-size=".64rem"
                    style="height: 0.87rem;font-size: .68267rem;"
                    :name="2"
                  >
                    非企业
                    <div
                      slot="icon"
                      slot-scope="props"
                      :class="
                        props.checked ? 'radio-active radio-wrp' : 'radio-wrp'
                      "
                    ></div>
                  </van-radio>
                </van-radio-group>
              </div>
              <van-cell-group
                v-if="buyerVo.nature === 1 || buyerVo.nature === 2"
                :border="false"
                class="item"
              >
                <div class="van-cell van-field" style="padding-left: 0px; color: rgb(51, 51, 51); font-size: 0.68267rem; line-height: 1.5;">
                  <div class="van-cell__title van-field__label" style="width: 3.55rem;">
                    <span>开票抬头</span>
                  </div>
                  <div class="van-cell__value van-field__value">
                    <div class="van-field__body">
                      <input type="text" style="color:#333" v-model="buyerVo.name" placeholder="请输入开票抬头" class="van-field__control">
                    </div>
                  </div>
                </div>
                <!-- <van-field
                  label-width="3.55rem"
                  style="padding-left: 0;color: #333;font-size: .68267remline-height: 1.5;"
                  v-model="buyerVo.name"
                  label="开票抬头"
                  maxlength="50"
                  placeholder="请输入开票抬头"
                  @blur="testBuyerName"
                /> -->
              </van-cell-group>
              <van-cell-group
                v-if="buyerVo.nature === 0"
                :border="false"
                class="item"
                style="position: relative"
              >
                <div class="van-cell van-field" style="padding-left: 0px; color: rgb(51, 51, 51); font-size: 0.68267rem; line-height: 1.5;">
                  <div class="van-cell__title van-field__label" style="width: 3.55rem;">
                    <span>开票抬头</span>
                  </div>
                  <div class="van-cell__value van-field__value">
                    <div class="van-field__body">
                      <input @focus="onSearchTitle" maxlength="50" v-model="buyerVo.name" @input="onSearch" type="text" style="color:#333" placeholder="请输入开票抬头" class="van-field__control">
                    </div>
                  </div>
                </div>
                <div v-if="formalinvoiceListShow" class="rollup">
                  <div
                    @click="onSelectCompany(item)"
                    class="rollup-item"
                    v-for="(item, index) in formalinvoiceList"
                    :key="index"
                  >
                    {{ item.name }}
                  </div>
                </div>
              </van-cell-group>
              <van-cell-group
                :border="false"
                class="item"
                v-if="buyerVo.nature === 0 || buyerVo.nature === 2"
              >
                <div class="van-cell van-field" style="padding-left: 0px; color: rgb(51, 51, 51); font-size: 0.68267rem; line-height: 1.5;">
                  <div class="van-cell__title van-field__label" style="width: 3.55rem;">
                    <span>开票税号</span>
                  </div>
                  <div class="van-cell__value van-field__value">
                    <div class="van-field__body">
                      <input v-model="buyerVo.ratepayingIdentify" @blur="testRatepayingIdentify" @focus="changeFocus" maxlength="100" type="text" placeholder="请输入开票税号" class="van-field__control" style="color: rgb(51, 51, 51);">
                    </div>
                  </div>
                </div>
              </van-cell-group>
              <van-cell-group :border="false" class="item">
                <div class="van-cell van-field" style="padding-left: 0px; color: rgb(51, 51, 51); font-size: 0.68267rem; line-height: 1.5;">
                  <div class="van-cell__title van-field__label" style="width: 3.55rem;">
                    <span>邮箱</span>
                  </div>
                  <div class="van-cell__value van-field__value">
                    <div class="van-field__body">
                      <input v-model="buyerVo.acceptEmail" @blur="testEmail" @focus="changeFocus" maxlength="100" type="text" placeholder="请输入邮箱" class="van-field__control" style="color: rgb(51, 51, 51);">
                    </div>
                  </div>
                </div>
              </van-cell-group>
              <van-cell-group
                :border="false"
                v-if="isShowMoreInfo && buyerVo.nature === 0"
                class="item"
              >
                <div class="van-cell van-field" style="padding-left: 0px; color: rgb(51, 51, 51); font-size: 0.68267rem; line-height: 1.5;">
                  <div class="van-cell__title van-field__label" style="width: 3.55rem;">
                    <span>地址电话</span>
                  </div>
                  <div class="van-cell__value van-field__value">
                    <div class="van-field__body">
                      <input v-model="buyerVo.address" @focus="changeFocus" maxlength="100" type="text" placeholder="请输入企业地址、电话" class="van-field__control" style="color: rgb(51, 51, 51);">
                    </div>
                  </div>
                </div>
              </van-cell-group>
              <van-cell-group
                :border="false"
                v-if="isShowMoreInfo && buyerVo.nature === 0"
                class="item"
              >
                <div class="van-cell van-field" style="padding-left: 0px; color: rgb(51, 51, 51); font-size: 0.68267rem; line-height: 1.5;">
                  <div class="van-cell__title van-field__label" style="width: 3.55rem;">
                    <span>银行账号</span>
                  </div>
                  <div class="van-cell__value van-field__value">
                    <div class="van-field__body">
                      <input v-model="buyerVo.bankName" @focus="changeFocus" maxlength="50" type="text" placeholder="请输入企业开户行地址、账号" class="van-field__control" style="color: rgb(51, 51, 51);">
                    </div>
                  </div>
                </div>
              </van-cell-group>

              <!-- <p
                v-if="buyerVo.nature === 0"
                :border="false"
                class="iconfont item"
                style="text-align: right; color: #666; line-height: 1.70667rem"
                @click="
                  () => {
                    isShowMoreInfo = !isShowMoreInfo;
                  }
                "
              >
                &#xec0c;
              </p> -->

            </div>
            <div class="order-date" v-if="!applyTaxMoneyDisabled">
              <div v-for="(item, index) in data.consumerDetails" :key="index">
                <div class="order-date-title">{{ `商品（${index + 1}）` }}</div>
                <div class="item">
                  <div class="order-date-left">商品/服务</div>
                  <div class="order-date-right">{{ item.goodsName }}</div>
                </div>
                <div class="item">
                  <div class="order-date-left">含税单价</div>
                  <div class="order-date-right">{{ item.price }}</div>
                </div>
                <div class="item">
                  <div class="order-date-left">数量</div>
                  <div class="order-date-right">{{ item.count }}</div>
                </div>
                <div class="item">
                  <div class="order-date-left">含税金额</div>
                  <div class="order-date-right">{{ item.moneyTax }}</div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </Layout>
    <div class="submit">
      <van-button @click="submitStatic" class="submit-btn" type="info">提交申请</van-button>
    </div>
  </div>
</template>

<script>
import Layout from '@components/Customer/CustomerLayout.vue'
import Header from '@components/Customer/CustomerHeader.vue'
import {
  NumberKeyboard,
  Field,
  CellGroup,
  RadioGroup,
  Radio,
  Button,
  Notify,
  Toast
} from 'vant'
import { ConvertNumber, getQuery, isEmail, debounce } from '@utils/basicUtil'
import { sweepCodeRequest } from '@services'

export default {
  data: () => ({
    fetching: false,
    formalinvoiceList: [],
    formalinvoiceListShow: false,
    applyTaxMoneyDisabled: false,
    data: {
      sellerCompanyName: '',
      applyTaxMoney: '',
      orderNo: '',
      consumerDetails: []
    },
    buyerVo: {
      nature: 0,
      name: '',
      acceptEmail: '',
      ratepayingIdentify: '',
      address: '',
      bankName: ''
    },
    isShowMoreInfo: false,
    companyId: '',
    invoiceType: '',
    userId: '',
    buyerNameTest: false,
    ratepayingIdentifyTest: false,
    emailTest: false
  }),
  mounted () {
    this.getQuery()
  },
  methods: {
    async getCompanyInfo () {
      const data = await sweepCodeRequest.company.getCompanyInfo({}, { id: this.companyId })
      if (data.success) {
        this.data.sellerCompanyName = data.result.name
      }
    },
    async getSmartTitles (companyName = this.buyerVo.name) {
      const data = await sweepCodeRequest.mobile.getSmartTitles({ companyName })
      if (data.success) {
        this.formalinvoiceList = data.result
      }
      this.fetching = false
    },
    ConvertNumber (data) {
      return ConvertNumber(data)
    },
    getQuery () {
      let queryObj = getQuery()
      if (queryObj.companyId) {
        this.applyTaxMoneyDisabled = false
        this.isShowMoreInfo = true
        this.companyId = queryObj.companyId
        this.invoiceType = queryObj.invoiceType
        this.getCompanyInfo(this.companyId)
      }
    },
    onSearch (value) {
      if (value.length < 4) {
        return
      }
      this.fetching = true
      debounce(this.getSmartTitles, 1000)()
    },
    onSelectCompany ({ address, bankName, bankNo, name, taxNo, tel }) {
      this.buyerVo.name = name
      this.buyerVo.ratepayingIdentify = taxNo
      this.buyerVo.address = `${address} ${tel}`
      this.buyerVo.bankName = `${bankName} ${bankNo}`
      this.formalinvoiceListShow = false
    },
    onSearchTitle () {
      this.changeFocus()
      this.formalinvoiceList = []
      this.formalinvoiceListLoading = true
      this.formalinvoiceListShow = true
    },
    onBlurTitle () {
      this.formalinvoiceList = []
      this.formalinvoiceListLoading = false
      this.formalinvoiceListShow = false
    },
    async submitStatic () {
      if (!this.buyerVo.name.length) {
        return Notify({ type: 'danger', message: '请填写发票抬头' })
      } else {
        this.testBuyerName()
        if (this.buyerNameTest === false) {
          return
        }
      }
      if (this.buyerVo.nature === 0) {
        if (!this.buyerVo.ratepayingIdentify.length) {
          return Notify({ type: 'danger', message: '请填写开票税号' })
        } else {
          this.testRatepayingIdentify()
          if (this.ratepayingIdentifyTest === false) {
            return
          }
        }
      }
      if (!this.buyerVo.acceptEmail.length || !isEmail(this.buyerVo.acceptEmail)) {
        return Notify({ type: 'danger', message: '请填写正确的邮箱' })
      }
      const postData = {
        companyId: this.companyId, // 公司id
        invoiceType: this.invoiceType,
        nature: this.buyerVo.nature,
        bankName: this.buyerVo.bankName,
        email: this.buyerVo.acceptEmail,
        name: this.buyerVo.name,
        taxNo: this.buyerVo.ratepayingIdentify,
        address: this.buyerVo.address
      }
      try {
        Toast.loading({
          message: '请求中...',
          forbidClick: true,
          duration: 0
        })
        const data = await sweepCodeRequest.buyer.preOrder(postData)
        if (data.success) {
          Toast.clear({
            clearAll: true
          })
          Notify({ type: 'success', message: '提交成功！' })
        }
      } catch (err) {
        if (err.success === false) {
          Toast.clear({
            clearAll: true
          })
          Notify({ type: 'danger', message: err.message })
        }
      }
    },
    changeFocus () {
      let u = navigator.userAgent
      let isAndroid = u.indexOf('Android') > -1 || u.indexOf('Linux') > -1
      if (isAndroid) {
        setTimeout(() => {
          document.activeElement.scrollIntoViewIfNeeded()
          document.activeElement.scrollIntoView()
        }, 500)
      }
    },
    testBuyerName () {
      if (!this.buyerVo.name.length) {
        return Notify({ type: 'danger', message: '请填写发票抬头' })
      } else {
        if (!/^[\u2E80-\uFE4F()（）]+$/.test(this.buyerVo.name.trim())) {
          this.buyerNameTest = false
          return Notify({ type: 'danger', message: '发票抬头格式有误' })
        } else {
          this.buyerNameTest = true
        }
      }
    },
    testRatepayingIdentify () {
      if (!this.buyerVo.ratepayingIdentify.length) {
        if (this.buyerVo.nature === 0) {
          return Notify({ type: 'danger', message: '请填写开票税号' })
        }
      } else {
        if (!/^[A-Z0-9]{9}$|^[A-Z0-9]{15}$|^[A-Z0-9]{18}$|^[A-Z0-9]{19}$|^[A-Z0-9]{20}$/.test(this.buyerVo.ratepayingIdentify.trim())) {
          this.ratepayingIdentifyTest = false
          return Notify({ type: 'danger', message: '开票税号格式有误' })
        } else {
          this.ratepayingIdentifyTest = true
        }
      }
    },
    testEmail () {
      if (!this.buyerVo.acceptEmail.length) {
        return Notify({ type: 'danger', message: '请填写邮箱' })
      } else {
        if (!/^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/.test(this.buyerVo.acceptEmail.trim())) {
          this.emailTest = false
          return Notify({ type: 'danger', message: '邮箱格式有误' })
        } else {
          this.emailTest = true
        }
      }
    },
    changeNatureType (data) {
      this.buyerVo.name = ''
      this.buyerVo.acceptEmail = ''
      this.buyerVo.ratepayingIdentify = ''
      this.buyerVo.address = ''
      this.buyerVo.bankName = ''
    }
  },
  components: {
    Layout,
    Header,
    [NumberKeyboard.name]: NumberKeyboard,
    [Field.name]: Field,
    [RadioGroup.name]: RadioGroup,
    [Radio.name]: Radio,
    [Button.name]: Button,
    [CellGroup.name]: CellGroup,
    [Toast.name]: Toast
  }
}
</script>

<style lang="less" scoped src="./index.less"/>
